<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Категории
                </div>
                <div class="ap-workspace-label-btn" v-on:click="addCategory">
                    <SVGPlus/>
                </div>
            </div>
<!--            <div class="ap-workspace-label-btn ap-add-left-margin">-->
<!--                <label class="ap-search">-->
<!--                    <input type="text" class="ap-search-input" placeholder="Найти категорию">-->
<!--                </label>-->
<!--            </div>-->
        </div>
        <vue-custom-scrollbar>
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <div class="custom-categories-table-row custom-head-row">
<!--                    <div class="custom-categories-table-label">№</div>-->
                    <div class="custom-categories-table-label">Название</div>
                    <!--                <div class="custom-categories-table-label">Изображение</div>-->
                    <div class="custom-categories-table-label">Опции</div>
                </div>
                <AdminCategoriesRecursive :categories="categories"/>
                <div v-if="waitingResponseToCategoriesRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка категорий продукции ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {modalMethods, urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import AdminCategoriesRecursive from "./AdminCategoriesRecursive";
    import AddCategory from "../../Modal/AdminPage/CategoriesPage/AddCategory";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";


    export default {
        name: "AdminCategories",
        mixins: [urlForStaticVue, modalMethods],
        components: {
            SpinnerTwo,
            AdminCategoriesRecursive,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        computed:{
            categories(){
                return this.$store.getters["adminPanel/categories/SELF"];
            },
            waitingResponseToCategoriesRequest() {
                return this.$store.state.adminPanel.categories.waitingResponseToCategoriesRequest;
            }
        },
        methods: {
            addCategory(){
                this.$modal.show(AddCategory, {}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            }
        },
        mounted() {
            this.$store.dispatch('adminPanel/categories/GET_CATEGORIES');
        }
    }
</script>

<style scoped>

</style>

<style>
    .custom-categories-table-row {
        width: 100%;
        display: grid;
        grid-template-columns: auto 80px;
        color: #626262;
        border-bottom: 1px solid #F2F2F2;
    }

    .custom-head-row {
        font-weight: bold;
    }

    .custom-data-row {
        /*cursor: pointer;*/
    }

    .custom-data-row:hover {
        background: #E9E9E9;
    }

    .custom-categories-table-label {
        display: flex;
        align-items: center;
        padding: 8px;
    }

    .central-data {
        justify-content: center;
    }
</style>
